'use strict'
var twentyninetimes = twentyninetimes || {}

twentyninetimes.youtubePlayer =
  twentyninetimes.youtubePlayer ||
  (function () {
    function init() {
      const videoBlocks = document.querySelectorAll('.youtube-player')

      if (videoBlocks)
        videoBlocks.forEach(function (block) {
          block.addEventListener('click', function () {
            var videoId = block.getAttribute('data-video-id')

            var iframe = document.createElement('iframe')
            iframe.setAttribute(
              'src',
              'https://www.youtube.com/embed/' + videoId + '?rel=0&autoplay=1'
            )
            iframe.setAttribute('frameborder', '0')
            iframe.setAttribute(
              'allow',
              'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            )
            iframe.setAttribute('allowfullscreen', '')

            block.innerHTML = ''
            block.appendChild(iframe)
          })
        })
    }

    return {
      init: init,
    }
  })()
